<div class="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 mt-8 gap-[30px]" *ngIf="!loading && !error">
    <div *ngFor="let article of articles | slice:0:3" class="group relative overflow-hidden bg-white dark:bg-slate-900 rounded-md shadow dark:shadow-gray-700 hover:shadow-md transition-all duration-500">
        <img *ngIf="article.thumbnailImage" [src]="article.thumbnailImage" alt="">
        <img *ngIf="!article.thumbnailImage" src="/assets/images/no-img.jpg" alt="">

        <div class="relative p-6">
            <div class="absolute start-6 -top-4">
                <span class="bg-violet-600 text-white text-[12px] px-2.5 py-1 font-semibold rounded-full h-5">{{ `ARTICLES.${article.category}` | translate}}</span>
            </div>

            <div class="">
                <div class="flex mb-4">
                    <span class="text-slate-400 text-[16px]"><i class="uil uil-calendar-alt text-slate-900 dark:text-white me-2"></i>{{article.updateTime || article.createTime | date:'mediumDate'}}</span>
                    <span class="text-slate-400 text-[16px] ms-3"><i class="uil uil-clock text-slate-900 dark:text-white me-2"></i>{{article.readTime}} {{ 'BLOG.READ_MIN' | translate }}</span>
                </div>

                <a [routerLink]="['/read', article.id]" class="title text-lg font-medium hover:text-violet-600 duration-500 ease-in-out">{{article.title}}</a>

                <div class="flex justify-between mt-4">
                    <a [routerLink]="['/read', article.id]" class="btn btn-link text-[16px] font-medium hover:text-violet-600 after:bg-violet-600 duration-500 ease-in-out">{{ 'BLOG.READ_MORE' | translate }} <i class="uil uil-arrow-right"></i></a>
                    <span class="text-slate-400 text-[16px]">by <a [routerLink]="'/creator-profile'" class="text-slate-900 dark:text-white hover:text-violet-600 dark:hover:text-violet-600 font-medium">{{article.author}}</a></span>
                </div>
            </div>
        </div>
    </div>
</div><!--end grid-->

<div *ngIf="loading" class="flex justify-center items-center py-10">
  <div class="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-violet-600"></div>
</div>

<div *ngIf="error" class="text-center mt-8">
  <div class="alert alert-danger">
    {{error | translate}}
  </div>
</div>
